/**
 * Third-party credits that are actually required.
 *
 * AI image models (SDXL, etc.) used only to produce sold art generally do not
 * require naming on a public attributions page — their licences restrict how
 * you use the model, not that you credit every output. Keep this list empty
 * unless a source demands credit (for example some motion-capture datasets).
 *
 * The studio test suite fails if a .bvh capture ships without a `motion` entry.
 */
export type AttributionCategory = 'motion';

export type Attribution = {
  id: string;
  category: AttributionCategory;
  name: string;
  usedFor: string;
  licence: string;
  href?: string;
  /** Exact wording a licence asks to reproduce, if any. */
  notice?: string;
};

export const ATTRIBUTION_CATEGORIES: {
  id: AttributionCategory;
  title: string;
  blurb: string;
}[] = [
  {
    id: 'motion',
    title: 'Animation',
    blurb: 'Third-party motion used in animated pieces, when credit is required.',
  },
];

/** Add entries only when a licence or dataset requires public credit. */
export const ATTRIBUTIONS: Attribution[] = [
  {
    id: 'bk-studio-baked-bvh',
    category: 'motion',
    name: 'Blind Kings studio pose library (baked BVH)',
    usedFor:
      'Walk, sword slash, and collapse captures under animation-studio/motion/sources/',
    licence: 'Original Blind Kings content — no third-party credit required',
    notice:
      'Replace with Mixamo or MoCap Online exports when upgrading motion; update this entry to match the new licence.',
  },
];

export function attributionsFor(category: AttributionCategory): Attribution[] {
  return ATTRIBUTIONS.filter((entry) => entry.category === category);
}
